import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DbEventsProvider } from 'src/app/providers/database/db.events';
import { DbAnalyticsProvider } from 'src/app/providers/database/db-analytics';
import { AppState } from 'src/app/shared/reducers';
import { Store } from '@ngrx/store';
import { FormatedEventLanguageService } from 'src/app/providers/formated-event-language/formated-event-language.service';
import { GlobalService } from 'src/app/providers/global/global.service';
import { getUsersAnalytics } from 'src/app/shared/selectors/analytics.selectors';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-users-analytics',
    templateUrl: './users-analytics.component.html',
    styleUrls: ['./users-analytics.component.scss']
})
export class UsersAnalyticsComponent implements OnInit {
    loader: boolean = true;

    event: any;
    eventId: string;
    userLanguage: string;

    totalUniqueUsers: number = 0;
    currentConnectedAttendees: number = 0;
    currentConnectedSpeakers: number = 0;
    totalUsersByModules: any[] = [];
    totalAttendees: number = 0;
    totalSpeakers: number = 0;

    constructor(
        private route: ActivatedRoute,
        private dbEvent: DbEventsProvider,
        private dbAnalytics: DbAnalyticsProvider,
        private global: GlobalService,
        public formatedLanguage: FormatedEventLanguageService,
        private store: Store<AppState>
    ) { }

    ngOnInit() {
        this.route.params.subscribe((params) => {
            this.eventId = params.uid;
            this.getUserLanguage()
            this.getEvent();
        })
    }

    getUserLanguage() {
        this.global.getLanguage((language) => {
            this.userLanguage = this.formatedLanguage.convertLang(language);
        })
    }

    getEvent() {
        this.dbEvent.getEvent(this.eventId, (event) => {
            this.event = event;
            this.formatedLanguage.convertLangFormat(event.language);
            this.dbAnalytics.getCurrentConnectedUsers(this.eventId);
            this.dbAnalytics.getUsersAnalytics(this.eventId).pipe(take(1)).subscribe(() => {
                this.store.select(getUsersAnalytics).subscribe((usersAnalytics) => {
                    this.totalUniqueUsers = (usersAnalytics && usersAnalytics.totalUniqueUsers) ? usersAnalytics.totalUniqueUsers : 0;
                    this.currentConnectedAttendees = (usersAnalytics && usersAnalytics.currentConnectedAttendees) ? usersAnalytics.currentConnectedAttendees : 0;
                    this.currentConnectedSpeakers = (usersAnalytics && usersAnalytics.currentConnectedSpeakers) ? usersAnalytics.currentConnectedSpeakers : 0;
                    this.totalUsersByModules = (usersAnalytics && usersAnalytics.totalUsersByModules) ? usersAnalytics.totalUsersByModules : [];
                    this.totalAttendees = (usersAnalytics && usersAnalytics.totalAttendees) ? usersAnalytics.totalAttendees : 0;
                    this.totalSpeakers = (usersAnalytics && usersAnalytics.totalSpeakers) ? usersAnalytics.totalSpeakers : 0;

                    this.loader = false;
                })
            });
        });
    }

    /**
     * Export users analytics
     */
    exportAll() {
        this.loader = true;
        this.dbAnalytics.exportUsersAnalytics(this.eventId).subscribe(() => {
            this.loader = false;
        }, (error) => {
            this.loader = false;
        })
    }
}
